import React from "react";
import { t } from "ttag";

import { PopupModal as Value } from "@reactivated";

import { ImageTile } from "../MediaGridBlock/ImageTile";
import { Modal, ModalRoot } from "../Modal";
import { usePopupModalIsOpen } from "./usePopupModalIsOpen";

import styles from "./index.module.scss";

interface Props {
    value: Value;
    id?: string;
}

export const PopupModalBlock = (props: Props) => {
    const [isOpen, handleOpenChange] = usePopupModalIsOpen(
        props.id || "",
        props.value.delay_seconds,
        !!props.value.content,
    );
    if (!props.value.content || !props.id) {
        return null;
    }
    return (
        <ModalRoot open={isOpen} onOpenChange={handleOpenChange}>
            <Modal
                contentLabel={t`Popup notification`}
                className={styles.modalContent}
                overlayClassName={styles.modalOverlay}
                closeClassName={styles.modalClose}
            >
                <div className={styles.modalImageContainer}>
                    <ImageTile value={props.value.content} numSiblings={0} />
                </div>
            </Modal>
        </ModalRoot>
    );
};
